module.exports = __webpack_public_path__ + "img/img-d82240ba.7efb0365.png";